import { ApiTableView } from 'components/ApiTable/components/ApiTableView';
import { useRef } from 'react';
import { SearchableSection } from '../DiscoverySearch/SearchableSection';
import { useSnapshotAttributesTable } from './hooks/useSnapshotAttributesTable';

type Props = {
  snapshotId: string;
  onUpdated: () => void;
};

export const DeviceAttributesList = (props: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { model: snapshotAttributesTableModel, renderConfirmDialog } =
    useSnapshotAttributesTable({
      snapshotId: props.snapshotId,
      containerRef,
      onUpdated: props.onUpdated,
    });

  return (
    <>
      <div
        className='flex flex-col flex-1 bg-default rounded-lg'
        ref={containerRef}
      >
        <SearchableSection
          id='device-attributes-list-table'
          searchTerms={['List of attributes']}
          highlightOn={['deviceAttributes']}
          className='flex flex-col flex-1'
          wrapperClassName='flex flex-col flex-1'
        >
          <ApiTableView
            model={snapshotAttributesTableModel}
            className='flex-1'
            tableClassName='bg-transparent'
          />
        </SearchableSection>
      </div>
      {renderConfirmDialog()}
    </>
  );
};
